import React from 'react';

function LoaderComponent() {
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      Loading ...
    </div>
  );
}

export default LoaderComponent;
